import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Radio, FormControlLabel, Slider, Tooltip, FormGroup, Stack, Switch, typographyClasses } from '@mui/material';
import Grid from "@mui/material/Grid2";

import { styled } from '@mui/material/styles';
import { CancelLightGreyIcon } from '../../../assets/icons';
import { automatedPriceMonthly, automatedPriceYearly, allInOnePriceMonthly, allInOnePriceYearly } from './pricingData';

// Custom styled components
const StyledSlider = styled(Slider)(({ theme }) => ({
    height: 4,
    '& .MuiSlider-thumb': {
        width: 24,
        height: 24,
        backgroundColor: '#fff',
        boxShadow: 'none',
        transition: "left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,bottom 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        cursor: "grab",
        '&:before, &:after, &:hover, &:focus': {
            boxShadow: 'none',
            transition: 'none',
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -42%)',
            width: '44px',
            height: '44px',
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='44' height='44' viewBox='0 0 44 44' fill='none'%3E%3Cg filter='url(%23filter0_d_32747_39531)'%3E%3Ccircle cx='22' cy='18' r='12' fill='white'/%3E%3Cpath d='M21.3757 8C21.7921 8 22.209 8 22.6254 8C22.9662 8.04436 23.3085 8.07723 23.6466 8.13515C25.5247 8.45607 27.1867 9.2409 28.6097 10.5074C30.3495 12.0556 31.4375 13.9785 31.8466 16.2767C31.9113 16.6404 31.9494 17.0083 32 17.3746V18.6243C31.9708 18.8623 31.9457 19.1008 31.9118 19.3382C31.6018 21.5048 30.7137 23.4027 29.167 24.9509C26.6002 27.5199 23.5 28.4764 19.9375 27.7735C17.5058 27.2939 15.5338 26.0066 14.0419 24.0325C12.3152 21.7485 11.6875 19.1676 12.1441 16.3408C12.4775 14.277 13.4022 12.4981 14.8659 11.0073C16.3641 9.48146 18.169 8.52496 20.2777 8.15394C20.6415 8.08975 21.0093 8.05062 21.3757 8ZM22.7392 18.0039C22.7392 18.7522 22.7366 19.5005 22.7397 20.2488C22.7434 20.9929 23.4306 21.3895 24.0777 21.018C25.3629 20.2801 26.6461 19.5391 27.9277 18.795C28.629 18.388 28.6259 17.6078 27.9209 17.1992C26.645 16.4588 25.3666 15.722 24.0876 14.9867C23.4296 14.6084 22.7423 15.0029 22.7392 15.7595C22.7361 16.5078 22.7392 17.2556 22.7392 18.0039ZM21.2614 17.9929C21.2614 17.2509 21.2635 16.5094 21.2609 15.7674C21.2582 15.0044 20.5835 14.6053 19.9224 14.9831C18.6189 15.7282 17.3185 16.4791 16.0207 17.2337C15.3982 17.5958 15.3935 18.3974 16.015 18.7595C17.318 19.5188 18.6236 20.2728 19.9333 21.0206C20.583 21.3916 21.2582 20.9882 21.2614 20.2373C21.2645 19.489 21.2614 18.7412 21.2614 17.9929Z' fill='%233F80E9'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_32747_39531' x='0' y='0' width='44' height='44' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='4'/%3E%3CfeGaussianBlur stdDeviation='5'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_32747_39531'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_32747_39531' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            pointerEvents: 'none',
        }
    },
    '& .MuiSlider-track': {
        height: 2,
        backgroundColor: '#3F80E9',
        borderRadius: 4,
        border: 'none',
    },
    '& .MuiSlider-mark': {
        backgroundColor: '#B8B7BD',
        height: 8,
        width: 8,
        borderRadius: 2,
        opacity: 1,

        '&Active': {
            backgroundColor: '#3F80E9',
        },

    },
    '& .MuiSlider-rail': {
        height: 2,
        backgroundColor: '#B8B7BD',
        borderRadius: 4,
    },
}));

// AntSwitch component from SubscriptionDetails
const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 24,
    padding: 0,
    display: 'flex',
    borderRadius: 50,
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(24px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        top: 1,
        '&.Mui-checked': {
            transform: 'translateX(19px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#22B060',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 18,
        height: 18,
        borderRadius: 24,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: '#22B060',
        boxSizing: 'border-box',
    },
}));

// SVG Icon Components
const TickSymbol = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7071 7.04289C15.0976 7.43342 15.0976 8.06658 14.7071 8.45711L5.75 17.4142L1.29289 12.9571C0.90237 12.5666 0.90237 11.9334 1.29289 11.5429C1.68342 11.1524 2.31658 11.1524 2.70711 11.5429L5.75 14.5858L13.2929 7.04289C13.6834 6.65237 14.3166 6.65237 14.7071 7.04289Z" fill="#178EFC" />
    </svg>
);

const InfoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
        <path d="M8.25 5.75H6.75V4.25H8.25M8.25 11.75H6.75V7.25H8.25M7.5 0.5C6.51509 0.5 5.53982 0.693993 4.62987 1.0709C3.71993 1.44781 2.89314 2.00026 2.1967 2.6967C0.790176 4.10322 0 6.01088 0 8C0 9.98912 0.790176 11.8968 2.1967 13.3033C2.89314 13.9997 3.71993 14.5522 4.62987 14.9291C5.53982 15.306 6.51509 15.5 7.5 15.5C9.48912 15.5 11.3968 14.7098 12.8033 13.3033C14.2098 11.8968 15 9.98912 15 8C15 7.01509 14.806 6.03982 14.4291 5.12987C14.0522 4.21993 13.4997 3.39314 12.8033 2.6967C12.1069 2.00026 11.2801 1.44781 10.3701 1.0709C9.46018 0.693993 8.48491 0.5 7.5 0.5Z" fill="#B8B8C4" />
    </svg>
);

interface PricingSectionProps {
    currentPlanId?: string;
    currentAttendees?: number;
    onPlanSelect: (planId: string) => void;
}

// Main component
const PricingSection: React.FC<PricingSectionProps> = ({ currentPlanId, currentAttendees, onPlanSelect }) => {
    // State
    const [planDuration, setPlanDuration] = useState<'monthly' | 'yearly'>('monthly');
    const [automatedValue, setAutomatedValue] = useState(0);
    const [aioValue, setAioValue] = useState(0);
    const [showIntegrations, setShowIntegrations] = useState({
        automated: false,
        aio: false,
        enterprise: false
    });

    // Slider options
    const attendeeOptions = [200, 500, 3000, 6000, 10000, "10000+"];
    const allInOneOptions = {
        leads: [100, 300, 1000, 3000, 6000, "6000+"],
        attendees: [50, 100, 500, 1000, 2000, "2000+"]
    };

    // Helper function to convert option to number
    const optionToNumber = (option: string | number): number => {
        return typeof option === 'string' ? parseInt(option.replace('+', '')) : option;
    };

    // Helper function to find the appropriate tier index
    const findTierIndex = (options: (string | number)[], targetValue: number): number => {
        // First try to find the exact tier
        const exactIndex = options.findIndex(option => optionToNumber(option) >= targetValue);

        if (exactIndex !== -1) {
            return exactIndex;
        }

        // If no exact match, find the highest tier that's less than targetValue
        for (let i = options.length - 1; i >= 0; i--) {
            if (optionToNumber(options[i]) <= targetValue) {
                return i;
            }
        }

        // Default to first tier if no match found
        return 0;
    };

    // Initialize slider values based on currentAttendees
    useEffect(() => {
        if (!currentAttendees || !currentPlanId) return;

        // Set plan duration based on currentPlanId
        if (currentPlanId.includes('-Yearly-')) {
            setPlanDuration('yearly');
        } else if (currentPlanId.includes('-Monthly-')) {
            setPlanDuration('monthly');
        }

        // Set the appropriate slider value based on plan type
        if (currentPlanId.includes('Automated-Gold')) {
            setAutomatedValue(findTierIndex(attendeeOptions, currentAttendees));
        } else if (currentPlanId.includes('All-In-One')) {
            setAioValue(findTierIndex(allInOneOptions.leads, currentAttendees));
        }
    }, [currentAttendees, currentPlanId]);

    // Handlers
    const handleDurationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPlanDuration(e.target.checked ? 'yearly' : 'monthly');
    };

    const handleSliderChange = (type: 'automated' | 'aio', value: number) => {
        if (type === 'automated') {
            setAutomatedValue(value);
        } else {
            setAioValue(value);
        }
    };

    const getStartForFree = (planType: 'automated' | 'aio' | 'free') => {
        const value = planType === 'automated'
            ? attendeeOptions[automatedValue]
            : planType === 'aio'
                ? allInOneOptions.leads[aioValue]
                : 30; // For free plan

        // Format the plan type
        const formattedPlanType = planType === 'automated' ? 'Automated-Gold' : planType === 'aio' ? 'All-In-One' : 'Free';
        const currency = 'USD';
        const duration = planDuration.charAt(0).toUpperCase() + planDuration.slice(1);
        const attendees = value.toString().replace('+', '');

        // Build the planId parameter in the required format
        const planId = `${formattedPlanType}-${currency}-${duration}-${attendees}`;

        // Call onPlanSelect instead of redirecting
        onPlanSelect(planId);
    };

    const contactSales = () => {
        window.location.href = "/demo/";
    };

    // Helper to get price for current plan
    const getPrice = (type: 'automated' | 'aio', index: number) => {
        const priceObj = type === 'automated'
            ? (planDuration === 'yearly' ? automatedPriceYearly : automatedPriceMonthly)
            : (planDuration === 'yearly' ? allInOnePriceYearly : allInOnePriceMonthly);

        const value = type === 'automated'
            ? attendeeOptions[index].toString()
            : allInOneOptions.leads[index].toString();

        return priceObj[value as keyof typeof priceObj]?.price || "**";
    };

    // Helper to get webinars count
    const getWebinars = (type: 'automated' | 'aio', index: number) => {
        const priceObj = type === 'automated'
            ? (planDuration === 'yearly' ? automatedPriceYearly : automatedPriceMonthly)
            : (planDuration === 'yearly' ? allInOnePriceYearly : allInOnePriceMonthly);

        const value = type === 'automated'
            ? attendeeOptions[index].toString()
            : allInOneOptions.leads[index].toString();

        return priceObj[value as keyof typeof priceObj]?.webinars || "**";
    };

    const integrationImages = [
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/hubspot-circle.png", alt: "HubSpot" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/convertkit-circle.png", alt: "Convertkit" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/mail-chimp-circle.png", alt: "Mailchimp" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/highlevel-circle.png", alt: "Highlevel" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/keep-circle.png", alt: "Keep" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/drip-circle.png", alt: "Drip" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/active-campaign-circle.png", alt: "ActiveCampaign" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/aweber-circle.png", alt: "Aweber" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/getresponse-circle.png ", alt: "GetResponse" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/icontact-circle.png", alt: "iContact" },
        { src: "https://easywebinar-site.s3.amazonaws.com/images/v3-images/ontraport-circle.png", alt: "Ontraport" },
    ];

    const handleShowIntegrations = (plan: 'automated' | 'aio' | 'enterprise') => {
        setShowIntegrations(prev => ({
            ...prev,
            [plan]: !prev[plan]
        }));
    };

    const getButtonText = (planType: 'automated' | 'allInOne', value: number) => {
        // Parse the current plan details from currentPlanId
        const planDetails = currentPlanId?.split('-') || [];

        if (!currentPlanId || !currentAttendees) return 'Buy Now';

        // Check if current plan matches the plan type
        const isCurrentPlanType = planType === 'automated'
            ? currentPlanId.includes('Automated-Gold')
            : currentPlanId.includes('All-In-One');
            
        // Check if current plan duration matches selected duration
        const isCurrentDuration = planDuration === 'yearly' 
            ? currentPlanId?.includes('Yearly')
            : currentPlanId?.includes('Monthly');

        // If it's a different plan type or different duration
        if (!isCurrentPlanType || !isCurrentDuration) {
            return 'Buy Now';
        }

        // If it's the same plan type and duration, compare attendees
        if (value > currentAttendees) {
            return 'Upgrade';
        } else if (value < currentAttendees) {
            return 'Downgrade';
        } else {
            return 'Current Plan';
        }
    };

    // Helper to get storage space
    const getStorage = (type: 'automated' | 'aio', index: number) => {
        const priceObj = type === 'automated'
            ? (planDuration === 'yearly' ? automatedPriceYearly : automatedPriceMonthly)
            : (planDuration === 'yearly' ? allInOnePriceYearly : allInOnePriceMonthly);

        const value = type === 'automated'
            ? attendeeOptions[index].toString()
            : allInOneOptions.leads[index].toString();

        const storage = priceObj[value as keyof typeof priceObj]?.storage || "Custom";
        return storage;
    };

    // Helper to get storage number for tooltip
    const getStorageNumber = (storage: string) => {
        return storage.split(' ')[0];
    };

    // Render main component
    return (
        <>
            <Box className="v3-pricing-plan-table" sx={{ my: 4 }}>
                <Box className="toggle-container" maxWidth="1200px">
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                        flexWrap="wrap"
                        gap="16px"
                    >
                        <Box color="#333" fontSize="24px" fontWeight="500">
                            Upgrade Plan
                        </Box>
                        <FormGroup>
                            <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                                <Typography color={planDuration === 'monthly' ? "#22B060" : "#000000"} fontWeight="500">
                                    Monthly
                                </Typography>
                                <AntSwitch
                                    checked={planDuration === 'yearly'}
                                    onChange={handleDurationChange}
                                    inputProps={{ "aria-label": "plan duration toggle" }}
                                />
                                <Typography display="flex" color={planDuration === 'yearly' ? "#22B060" : "#000000"} alignItems="center" gap={1} fontWeight="500">
                                    Annual{" "}
                                    <Typography component="span" color="#2B2B30" fontSize="12px">
                                        (2 Months Free)
                                    </Typography>
                                </Typography>
                            </Stack>
                        </FormGroup>
                    </Box>
                </Box>

                <Box className="ew-plan-boxes-con" >
                    <Grid container spacing={3} className="ew-pricing-plan-boxes" display="flex" justifyContent="center">
                        {/* Automated Gold Plan */}
                        <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }} display="flex" justifyContent="center">
                            <Paper className={`box evergreen-plan ${currentPlanId?.includes('Automated-Gold') ? 'active-plan' : ''}`} sx={{
                                height: '100%',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                boxShadow: '0 5px 15px rgba(0, 0, 0, 0.08)'
                            }}>
                                <Box className="inner-content" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <Box className="top-content" sx={{ p: 3 }}>
                                        <Typography variant="h4" fontWeight="600" sx={{ mb: 1 }} color="#1A1E3E" fontSize="32px">Automated Gold</Typography>
                                        <Typography variant="body2" sx={{ mb: 2, color: '#000000' }} fontWeight={600}>Live-like recorded and Evergreen</Typography>
                                        {
                                            automatedValue == 5 ?
                                                <Box py={{ xs: "16px", sm: "27px" }}>
                                                    <Typography
                                                        fontSize="min(18px, calc(16px + 2 * (100vw - 320px) / 1600))"
                                                        variant="subtitle1"
                                                        color="#178EFC"
                                                        fontWeight={500}
                                                    >
                                                        Please book a call and get a quote
                                                    </Typography>
                                                </Box>
                                                : <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }} justifyContent="center">
                                                    <Typography component="span" sx={{ fontSize: '36px', mr: 0.5 }} fontWeight={800}>$</Typography>
                                                    <Typography component="span" sx={{ fontSize: '46px', fontWeight: 'bold' }}>
                                                        {getPrice('automated', automatedValue)}
                                                    </Typography>
                                                    <Box component="span" sx={{ fontSize: 'min(18px, 11px + 7 * (100vw - 320px) / 1600)', color: '#00000080', ml: 1 }} fontWeight={600} textAlign="start" lineHeight="normal">
                                                        /month {planDuration === 'yearly' && <br />}
                                                        {planDuration === 'yearly' && 'Billed annually'}
                                                    </Box>
                                                </Box>}

                                        <Box className="pricing-slider__label">
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography component="span" variant="body1" color="rgba(0, 0, 0, 0.5)">
                                                    <Box component="span" fontWeight="600">{attendeeOptions[automatedValue]} </Box>
                                                    Leads
                                                </Typography>
                                                <Tooltip arrow title="Lead refers to the total number of registrations and attendees who can watch the webinar.">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1 }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                        </Box>

                                        <Box className="pricing-slider" sx={{ mb: 3 }}>
                                            <Box sx={{ position: 'relative', mt: { xs: 2, sm: 4 }, mb: 2 }}>
                                                <StyledSlider
                                                    value={automatedValue}
                                                    onChange={(_, value) => handleSliderChange('automated', value as number)}
                                                    min={0}
                                                    max={5}
                                                    step={1}
                                                    marks
                                                />
                                            </Box>
                                        </Box>

                                        <Box sx={{ textAlign: 'center' }}>
                                            <Button
                                                variant="contained"
                                                size="large"
                                                disabled={getButtonText('automated', parseInt(attendeeOptions[automatedValue] as string)) === 'Current Plan'}
                                                sx={{
                                                    width: '100%',
                                                    borderRadius: '30px',
                                                    px: 3,
                                                    py: 1.5,
                                                    height: '48px',
                                                    backgroundColor: allInOneOptions.leads[automatedValue] === "6000+" ? '#000000' : '',
                                                    '&:hover': {
                                                        backgroundColor: allInOneOptions.leads[automatedValue] === "6000+" ? '#302f2f' : ''
                                                    }
                                                }}
                                                onClick={() => attendeeOptions[automatedValue] === "10000+"
                                                    ? contactSales()
                                                    : getStartForFree('automated')
                                                }
                                            >
                                                {attendeeOptions[automatedValue] === "10000+"
                                                    ? 'Book a Call'
                                                    : getButtonText('automated', parseInt(attendeeOptions[automatedValue] as string))}
                                            </Button>
                                            <Typography
                                                variant="caption"
                                                component="a"
                                                href="https://easywebinar.com/terms-conditions/#:~:text=2.-,Pricing%20and%20Payment,-Subscription%20Plans%3A%20We"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    display: 'block',
                                                    mt: 1,
                                                    color: '#888',
                                                    textDecoration: 'none',
                                                    '&:hover': {
                                                        textDecoration: 'underline'
                                                    }
                                                }}
                                            >
                                                *Overages may apply
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box className="plan-features" sx={{ p: 3, flex: 1 }}>
                                        <Typography variant="body2" fontWeight="600" sx={{ b: 2, fontSize: 'min(22px, calc(16px + (22 - 16) * ((100vw - 320px) / (1920 - 320))))' }} mb="24px">Features</Typography>
                                        <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, mb: 3 }}>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">
                                                        <Box component="strong">
                                                            {automatedValue == 5 ? "10K+" : (
                                                                <>
                                                                    <Typography component="span" fontWeight="400" fontSize="inherit">Up to </Typography>
                                                                    {attendeeOptions[automatedValue]}
                                                                </>
                                                            )}
                                                        </Box> attendees (Pre-recorded)
                                                    </Typography>
                                                </Box>
                                                <Tooltip arrow title="Host pre-recorded evergreen webinars that run 24/7 in each attendee's local timezone—perfect for global reach.">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <Box >
                                                    <Box display="flex">
                                                        {parseInt(attendeeOptions[automatedValue] as string) >= 500 ? <TickSymbol /> : <CancelLightGreyIcon />}
                                                    </Box>
                                                </Box>
                                                <Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Typography
                                                            variant="body2"
                                                            style={{
                                                                opacity: parseInt(attendeeOptions[automatedValue] as string) >= 500 ? 1 : 0.5
                                                            }}
                                                        >
                                                            Just-in-time
                                                        </Typography>
                                                        <Tooltip arrow title="Registrants can watch the webinar in their local timezone.">
                                                            <Box component="span" sx={{ display: 'inline-flex', ml: 1 }}>
                                                                <InfoIcon />
                                                            </Box>
                                                        </Tooltip>
                                                    </Box>
                                                    <Typography variant="caption" sx={{ display: 'block', color: '#178EFC' }}>
                                                        {parseInt(attendeeOptions[automatedValue] as string) >= 500
                                                            ? ''
                                                            : '(Unlock with 500+ leads/attendees)'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">
                                                        <Box component="strong">{automatedValue == 5 ? "6+" : (<><Typography component="span" fontWeight="400" fontSize="inherit">Up to </Typography> {getWebinars('automated', automatedValue)}</>)} </Box> pre-recorded webinars
                                                    </Typography>
                                                </Box>
                                                <Tooltip arrow title="Start with 2 evergreen webinars. Unlock more by upgrading your trial or plan.">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2"><strong>{getStorage('automated', automatedValue)}</strong> storage space</Typography>
                                                </Box>
                                                {getStorage('automated', automatedValue) !== "Custom" && (
                                                    <Tooltip arrow title={`${getStorageNumber(getStorage('automated', automatedValue))} GB free included. Add-on 5 GB for $5, or pay $2/GB overage without an add-on.`}>
                                                        <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                            <InfoIcon />
                                                        </Box>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">On demand</Typography>
                                                </Box>
                                                <Tooltip arrow title="Run On-Demand timed video events with Continue where you left off technology and email segmentation to match">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Page builder</Typography>
                                                </Box>
                                                <Tooltip arrow title="Utilize our Personalized Page Builder to create webinar landing pages tailored to your exact specifications. Each page will be meticulously designed according to your specific requests.">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Data export & analystics</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Embed registration</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Simulated events & chat</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">VIP support</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">VIP onboarding</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Unlimited team licences</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Unlimited live webinars</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Live attendees</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Up to 4 presenters</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>HD audio and video</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Dedicated account manager</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>API access</Typography>
                                                </Box>
                                                <Tooltip arrow title="User can get access to the registration API">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Unlimited events</Typography>
                                                </Box>
                                            </Box>
                                            <Typography variant="body2" fontWeight="600" sx={{ b: 2, fontSize: 'min(22px, calc(16px + (22 - 16) * ((100vw - 320px) / (1920 - 320))))' }} my="24px">Add-Ons</Typography>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Multiple workspaces</Typography>
                                                </Box>
                                                <Tooltip arrow title="Users will be able to create multiple sub-workspaces">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2"><strong>5 GB</strong> extra storage</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">CName</Typography>
                                                </Box>
                                                <Tooltip arrow title="Custom domain name">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Extra leads</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Elite Mastery Certification</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Custom API quota</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Sessions monitoring</Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                        <Typography variant="body2" color="initial" sx={{ mb: 1.5 }}>Integrate with</Typography>
                                        <Box className="integration-icons" sx={{ display: 'flex', gap: 1, alignItems: 'start' }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: 1,
                                                    alignItems: 'center',
                                                    maxWidth: "230px",
                                                    width: "100%",
                                                    position: 'relative',
                                                    height: showIntegrations.automated ? '68px' : '35px',
                                                    transition: 'height 0.3s ease-in-out',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                {integrationImages.map((img, index) => (
                                                    <Tooltip
                                                        key={index}
                                                        title={img.alt}
                                                        arrow
                                                    >
                                                        <Box
                                                            component="img"
                                                            src={img.src}
                                                            alt={img.alt}
                                                            sx={{
                                                                width: 30,
                                                                height: 30,
                                                                borderRadius: '50%',
                                                                position: 'absolute',
                                                                top: index < 6 ? '0' : '36px',
                                                                left: `${(index % 6) * 40}px`,
                                                                opacity: showIntegrations.automated || index < 6 ? 1 : 0,
                                                                transform: showIntegrations.automated || index < 6 ? 'translateY(0)' : 'translateY(20px)',
                                                                transition: 'all 0.3s ease-in-out',
                                                                transitionDelay: `${index * 0.05}s`
                                                            }}
                                                        />
                                                    </Tooltip>
                                                ))}
                                            </Box>
                                            <Typography
                                                mt="6px"
                                                variant="caption"
                                                onClick={() => handleShowIntegrations('automated')}
                                                sx={{
                                                    color: '#000000',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                {showIntegrations.automated ? '- Less' : '+More'}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>

                        {/* All-in-One Plan */}
                        <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }} display="flex" justifyContent="center">
                            <Paper className={`box all-in-one-plan ${currentPlanId?.includes('All-In-One') ? 'active-plan' : ''}`} sx={{
                                height: '100%',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                borderTop: '4px solid #0205C8',
                                boxShadow: '0 5px 15px rgba(0, 0, 0, 0.08)'
                            }}>
                                <Box className="inner-content" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <Box className="top-content" sx={{ p: 3 }}>
                                        <Typography variant="h4" fontWeight="600" sx={{ mb: 1 }} color="#1A1E3E" fontSize="32px">All-in-One</Typography>
                                        <Typography variant="body2" sx={{ mb: 2, color: '#000000' }} fontWeight={600}>Live, Hybrid, Automated and Evergreen</Typography>
                                        {aioValue == 5 ?
                                            <Box py={{ xs: "16px", sm: "27px" }}>
                                                <Typography fontSize="min(18px, calc(16px + 2 * (100vw - 320px) / 1600))" variant="subtitle1" color="#178EFC" fontWeight={500}>Please book a call and get a quote</Typography>
                                            </Box>
                                            : <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }} justifyContent="center">
                                                <Typography component="span" sx={{ fontSize: '36px', mr: 0.5 }} fontWeight={800}>$</Typography>
                                                <Typography component="span" sx={{ fontSize: '46px', fontWeight: '800' }}>
                                                    {getPrice('aio', aioValue)}
                                                </Typography>
                                                <Box component="span" sx={{ fontSize: 'min(18px, 11px + 7 * (100vw - 320px) / 1600)', color: '#00000080', ml: 1 }} fontWeight={600} textAlign="start" lineHeight="normal">
                                                    /month {planDuration === 'yearly' && <br />}
                                                    {planDuration === 'yearly' && 'Billed annually'}
                                                </Box>
                                            </Box>
                                        }
                                        <Box className="pricing-slider__label" sx={{ mb: 1 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography component="span" variant="body1" color="rgba(0, 0, 0, 0.5)">
                                                    <Box component="span" fontWeight="700">{allInOneOptions.leads[aioValue]} </Box>
                                                    Leads & <Box component="span" fontWeight="700">{allInOneOptions.attendees[aioValue]} </Box>
                                                    Live Attendees
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box className="pricing-slider" sx={{ mb: 3, mx: 1 }}>
                                            <Box sx={{ position: 'relative', mt: { xs: 2, sm: 4 }, mb: 2 }}>
                                                <StyledSlider
                                                    value={aioValue}
                                                    onChange={(_, value) => handleSliderChange('aio', value as number)}
                                                    min={0}
                                                    max={5}
                                                    step={1}
                                                    marks
                                                />
                                            </Box>
                                        </Box>

                                        <Box sx={{ textAlign: 'center' }}>
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                size="large"
                                                disabled={getButtonText('allInOne', parseInt(allInOneOptions.leads[aioValue] as string)) === 'Current Plan'}
                                                sx={{
                                                    borderRadius: '30px',
                                                    px: 3,
                                                    py: 1.5,
                                                    height: '48px',
                                                    backgroundColor: allInOneOptions.leads[aioValue] === "6000+" ? '#000000' : '',
                                                    '&:hover': {
                                                        backgroundColor: allInOneOptions.leads[aioValue] === "6000+" ? '#302f2f' : ''
                                                    }
                                                }}
                                                onClick={() => allInOneOptions.leads[aioValue] === "6000+"
                                                    ? contactSales()
                                                    : getStartForFree('aio')
                                                }
                                            >
                                                {allInOneOptions.leads[aioValue] === "6000+"
                                                    ? 'Book a Call'
                                                    : getButtonText('allInOne', parseInt(allInOneOptions.leads[aioValue] as string))}
                                            </Button>
                                            <Typography
                                                variant="caption"
                                                component="a"
                                                href="https://easywebinar.com/terms-conditions/#:~:text=2.-,Pricing%20and%20Payment,-Subscription%20Plans%3A%20We"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    display: 'block',
                                                    mt: 1,
                                                    color: '#888',
                                                    textDecoration: 'none',
                                                    '&:hover': {
                                                        textDecoration: 'underline'
                                                    }
                                                }}
                                            >
                                                *Overages may apply
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box className="plan-features" sx={{ p: 3, flex: 1 }}>
                                        <Typography variant="body2" fontWeight="600" sx={{ b: 2, fontSize: 'min(22px, calc(16px + (22 - 16) * ((100vw - 320px) / (1920 - 320))))' }} mb="24px">Features</Typography>
                                        <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, mb: 3 }}>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">
                                                        <Box component="strong">
                                                            {aioValue == 5 ? "6000+" : (
                                                                <>
                                                                    <Typography component="span" fontWeight="400" fontSize="inherit">Up to </Typography>
                                                                    {allInOneOptions.leads[aioValue]}
                                                                </>
                                                            )}
                                                        </Box> attendees (Pre-recorded)
                                                    </Typography>
                                                </Box>
                                                <Tooltip arrow title="Host pre-recorded evergreen webinars that run 24/7 in each attendee's local timezone—perfect for global reach.">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "4px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">
                                                        <Box component="strong">{aioValue == 5 ? "2000+" : (
                                                            <>
                                                                <Typography component="span" fontWeight="400" fontSize="inherit">Up to </Typography>
                                                                {allInOneOptions.attendees[aioValue]}
                                                            </>
                                                        )}</Box> attendees (Live)
                                                    </Typography>
                                                </Box>
                                                <Tooltip arrow title="Each person who joins live is counted as a unique live contact">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "4px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <Box display="flex">
                                                    {
                                                        parseInt(attendeeOptions[aioValue] as string) > 500 ? <TickSymbol /> : <CancelLightGreyIcon />
                                                    }
                                                </Box>
                                                <Box >
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Typography variant="body2" style={{
                                                            opacity: parseInt(attendeeOptions[aioValue] as string) > 500 ? 1 : 0.5
                                                        }}>Just-In-Time</Typography>
                                                        <Tooltip arrow title="Registrants can watch the webinar in their local timezone">
                                                            <Box component="span" sx={{ display: 'inline-flex', ml: 1 }}>
                                                                <InfoIcon />
                                                            </Box>
                                                        </Tooltip>
                                                    </Box>
                                                    <Typography variant="caption" sx={{ display: 'block', color: '#178EFC' }}>
                                                        {parseInt(allInOneOptions.leads[aioValue] as string) >= 500
                                                            ? ''
                                                            : '(Unlock with 500+ leads/attendees)'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">
                                                        <Box component="strong">{aioValue == 5 ? "6+" : (
                                                            <>
                                                                <Typography component="span" fontWeight="400" fontSize="inherit">Up to </Typography>
                                                                {getWebinars('aio', aioValue)}
                                                            </>
                                                        )}</Box> pre-recorded webinars
                                                    </Typography>
                                                </Box>
                                                <Tooltip arrow title="Start with 3 evergreen webinars. Unlock more by upgrading your trial or plan.">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "4px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>

                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2"><strong>{getStorage('aio', aioValue)}</strong> storage space</Typography>
                                                </Box>
                                                {getStorage('aio', aioValue) !== "Custom" && (
                                                    <Tooltip arrow title={`${getStorageNumber(getStorage('aio', aioValue))} GB free included. Add-on 5 GB for $5, or pay $2/GB overage without an add-on.`}>
                                                        <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                            <InfoIcon />
                                                        </Box>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">On demand</Typography>
                                                </Box>
                                                <Tooltip arrow title="Run On-Demand timed video events with Continue where you left off technology and email segmentation to match">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Page builder</Typography>
                                                </Box>
                                                <Tooltip arrow title="Utilize our Personalized Page Builder to create webinar landing pages tailored to your exact specifications. Each page will be meticulously designed according to your specific requests.">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Data export & analystics</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Embed registration</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Simulated events & chat</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">VIP support</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">VIP onboarding</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Unlimited team licences</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Unlimited live webinars</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Up to 4 presenters</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">HD audio and video</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Dedicated account manager</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>API access</Typography>
                                                </Box>
                                                <Tooltip arrow title="User can get access to the registration API">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Unlimited events</Typography>
                                                </Box>
                                            </Box>
                                            <Typography variant="body2" fontWeight="600" sx={{ b: 2, fontSize: 'min(22px, calc(16px + (22 - 16) * ((100vw - 320px) / (1920 - 320))))' }} my="24px">Add-Ons</Typography>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Multiple workspaces</Typography>
                                                </Box>
                                                <Tooltip arrow title="Users will be able to create multiple sub-workspaces">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2"><strong>5 GB</strong> extra storage</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">CName</Typography>
                                                </Box>
                                                <Tooltip arrow title="Custom domain name">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Extra leads</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Elite Mastery Certification</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Custom API quota</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <CancelLightGreyIcon />
                                                <Box>
                                                    <Typography variant="body2" sx={{ color: '#B8B7BD' }}>Sessions monitoring</Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                        <Typography variant="body2" color="initial" sx={{ mb: 1.5 }}>Integrate with</Typography>
                                        <Box className="integration-icons" sx={{ display: 'flex', gap: 1, alignItems: 'start' }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: 1,
                                                    alignItems: 'center',
                                                    maxWidth: "230px",
                                                    width: "100%",
                                                    position: 'relative',
                                                    height: showIntegrations.aio ? '68px' : '35px',
                                                    transition: 'height 0.3s ease-in-out',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                {integrationImages.map((img, index) => (
                                                    <Tooltip
                                                        key={index}
                                                        title={img.alt}
                                                        arrow
                                                    >
                                                        <Box
                                                            component="img"
                                                            src={img.src}
                                                            alt={img.alt}
                                                            sx={{
                                                                width: 30,
                                                                height: 30,
                                                                borderRadius: '50%',
                                                                position: 'absolute',
                                                                top: index < 6 ? '0' : '36px',
                                                                left: `${(index % 6) * 40}px`,
                                                                opacity: showIntegrations.aio || index < 6 ? 1 : 0,
                                                                transform: showIntegrations.aio || index < 6 ? 'translateY(0)' : 'translateY(20px)',
                                                                transition: 'all 0.3s ease-in-out',
                                                                transitionDelay: `${index * 0.05}s`
                                                            }}
                                                        />
                                                    </Tooltip>
                                                ))}
                                            </Box>
                                            <Typography
                                                mt="6px"
                                                variant="caption"
                                                onClick={() => handleShowIntegrations('aio')}
                                                sx={{
                                                    color: '#000000',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                {showIntegrations.aio ? '- Less' : '+More'}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>

                        {/* Enterprise Plan */}
                        <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }} display="flex" justifyContent="center">
                            <Paper className={`box enterprise ${currentPlanId?.includes('Enterprise') ? 'active-plan' : ''}`} sx={{
                                height: '100%',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                borderTop: '4px solid #A7CAE6',
                                boxShadow: '0 5px 15px rgba(0, 0, 0, 0.08)'
                            }}>
                                <Box className="inner-content" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <Box className="top-content" sx={{ p: 3 }}>
                                        <Typography variant="h4" fontWeight="600" sx={{ mb: 1 }} color="#1A1E3E" fontSize="32px">Enterprise</Typography>
                                        <Typography variant="body2" sx={{ mb: 2, color: '#000000' }} fontWeight={600}>Engineered for Massive Reach</Typography>
                                        <Box sx={{ mb: 3, m: "44px 0", display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                            <Typography component="span" sx={{ fontSize: '16px' }} color="#7F7F7F" fontWeight={600}>Up to </Typography>
                                            <Typography component="span" sx={{ fontSize: '46px', fontWeight: '800' }}>500K</Typography>
                                            <Typography component="span" sx={{ fontSize: '16px' }} color="#7F7F7F" fontWeight={600}>Attendees/Active Leads</Typography>
                                        </Box>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                size="large"
                                                sx={{
                                                    borderRadius: '30px',
                                                    px: 3,
                                                    py: 1.5,
                                                    backgroundColor: '#000000',
                                                    height: '48px',
                                                    '&:hover': {
                                                        backgroundColor: '#302f2f'
                                                    }
                                                }}
                                                onClick={contactSales}
                                            >
                                                Book a Demo
                                            </Button>
                                            <Typography
                                                variant="caption"
                                                component="a"
                                                href="https://easywebinar.com/terms-conditions/#:~:text=2.-,Pricing%20and%20Payment,-Subscription%20Plans%3A%20We"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    display: 'block',
                                                    mt: 1,
                                                    color: '#888',
                                                    textDecoration: 'none',
                                                    '&:hover': {
                                                        textDecoration: 'underline'
                                                    }
                                                }}
                                            >
                                                *Overages may apply
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box className="plan-features" sx={{ p: 3, flex: 1 }}>
                                        <Typography variant="body2" fontWeight="600" sx={{ b: 2, fontSize: 'min(22px, calc(16px + (22 - 16) * ((100vw - 320px) / (1920 - 320))))' }} mb="24px">Features</Typography>
                                        <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, mb: 3 }}>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">
                                                        Up to <strong>500K</strong> attendees
                                                    </Typography>
                                                </Box>
                                                <Tooltip arrow title="Includes Automated & Evergreen">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Custom live attendees</Typography>
                                                </Box>
                                                <Tooltip arrow title="Each person who joins live is counted as a unique live contact">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "4px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Just-in-time</Typography>
                                                </Box>
                                                <Tooltip arrow title="Registrants can watch the webinar in their local timezone">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "4px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Unlimited pre-recorded webinars</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Custom storage space</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">On demand</Typography>
                                                </Box>
                                                <Tooltip arrow title="Run On-Demand timed video events with Continue where you left off technology and email segmentation to match">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Page builder</Typography>
                                                </Box>
                                                <Tooltip arrow title="Utilize our Personalized Page Builder to create webinar landing pages tailored to your exact specifications. Each page will be meticulously designed according to your specific requests.">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Data export & analystics</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Embed registration</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Simulated events & chat</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">VIP support</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">VIP onboarding</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Unlimited team licences</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Unlimited live webinars</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Up to 4 presenters</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">HD audio and video</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Dedicated account manager</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">API Access</Typography>
                                                </Box>
                                                <Tooltip arrow title="User can get access to the registration API">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Unlimited events</Typography>
                                                </Box>
                                            </Box>
                                            <Typography variant="body2" fontWeight="600" sx={{ b: 2, fontSize: 'min(22px, calc(16px + (22 - 16) * ((100vw - 320px) / (1920 - 320))))' }} my="24px">Add-Ons</Typography>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Multiple workspaces</Typography>
                                                </Box>
                                                <Tooltip arrow title="Users will be able to create multiple sub-workspaces">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2"><strong>5 GB</strong> extra storage</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">CName</Typography>
                                                </Box>
                                                <Tooltip arrow title="Custom domain name">
                                                    <Box component="span" sx={{ display: 'inline-flex', ml: 1, mt: "3px" }}>
                                                        <InfoIcon />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Extra leads</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Elite Mastery Certification</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Custom API quota</Typography>
                                                </Box>
                                            </Box>
                                            <Box component="li" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                                                <TickSymbol />
                                                <Box>
                                                    <Typography variant="body2">Sessions monitoring</Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                        <Typography variant="body2" color="initial" sx={{ mb: 1.5 }}>Integrate with</Typography>
                                        <Box className="integration-icons" sx={{ display: 'flex', gap: 1, alignItems: 'start' }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: 1,
                                                    alignItems: 'center',
                                                    maxWidth: "230px",
                                                    width: "100%",
                                                    position: 'relative',
                                                    height: showIntegrations.enterprise ? '68px' : '35px',
                                                    transition: 'height 0.3s ease-in-out',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                {integrationImages.map((img, index) => (
                                                    <Tooltip
                                                        key={index}
                                                        title={img.alt}
                                                        arrow
                                                    >
                                                        <Box
                                                            component="img"
                                                            src={img.src}
                                                            alt={img.alt}
                                                            sx={{
                                                                width: 30,
                                                                height: 30,
                                                                borderRadius: '50%',
                                                                position: 'absolute',
                                                                top: index < 6 ? '0' : '36px',
                                                                left: `${(index % 6) * 40}px`,
                                                                opacity: showIntegrations.enterprise || index < 6 ? 1 : 0,
                                                                transform: showIntegrations.enterprise || index < 6 ? 'translateY(0)' : 'translateY(20px)',
                                                                transition: 'all 0.3s ease-in-out',
                                                                transitionDelay: `${index * 0.05}s`
                                                            }}
                                                        />
                                                    </Tooltip>
                                                ))}
                                            </Box>
                                            <Typography
                                                mt="6px"
                                                variant="caption"
                                                onClick={() => handleShowIntegrations('enterprise')}
                                                sx={{
                                                    color: '#000000',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                {showIntegrations.enterprise ? '- Less' : '+More'}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Box >
        </>
    );
};

export default PricingSection; 